<template>
  <div class="footer-container">
    <div class="left">
      <a href="https://codewarbler.github.io/#crowser">About</a>
      <a href="https://codewarbler.github.io/crowser/#examples">Examples</a>
      <a href="https://github.com/codewarbler/crowser">Github</a>
      <!-- <a href="https://twitter.com/codewarbler">Twitter</a> -->
    </div>
    <div class="right">
      <span>
        <abbr :title="`Build ${VUE_APP_GIT_REV} from ${VUE_APP_BUILD_DATE}`">
          Crowser {{ VUE_APP_WARBLER_VERSION }}
        </abbr>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    let date = new Date(parseInt(process.env.VUE_APP_BUILD_DATE, 10));
    return {
      VUE_APP_WARBLER_VERSION: process.env.VUE_APP_WARBLER_VERSION,
      VUE_APP_BUILD_DATE: date.toUTCString(),
      VUE_APP_GIT_REV: process.env.VUE_APP_GIT_REV,
    };
  },
};
</script>

<style lang="scss" scoped>
.footer-container {
  color: #999;
  background-color: #222;
  font-size: 0.9em;
  span {
    margin-right: 18px;
  }
  a {
    color: #999;
    text-decoration: none;
    margin-right: 12px;
    &:hover {
      color: white;
      // text-decoration: underline;
    }
  }
  .left {
    float: left;
    margin-top: 10px;
    margin-left: 16px;
  }
  .right {
    margin-top: 10px;
    margin-right: 10px;
    float: right;
  }
  abbr {
    text-decoration: none;
  }
}
</style>
